import React from 'react';
import { Button } from 'anf-core-react';
import TmntText from '../Common/Text/TmntText';
import { shareGiftReceiptProps } from './props';
import { useCustomTealiumTrigger } from '../../hooks/useTealiumTrigger';

export default function ShareGiftReceipt({ label }) {
  const analyticsData = {
    eventName: 'universal_click',
    eventData: {
      event_name: 'click',
      tealium_event: 'click',
      data_text: 'gift receipt',
      data_action: 'share',
    },
  };
  const includeDatabridgeDatapoints = false;
  const triggerAnalytics = useCustomTealiumTrigger(analyticsData, includeDatabridgeDatapoints);

  const onShare = () => {
    triggerAnalytics();
  };

  return (
    <Button variant="tertiary-light" isFullWidth onClick={onShare}>
      <TmntText tmnt={label} />
    </Button>
  );
}

ShareGiftReceipt.propTypes = shareGiftReceiptProps;

ShareGiftReceipt.defaultProps = {
  label: {
    key: '',
    value: '',
  },
};
